import { ACTIONS } from '../../modules/constants';

const INITIAL_STATE = {
  mobileHomeLength: 1, // 1 2 or 3 (Single/Double/Triple-wide)
};

export default function reducer(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case ACTIONS.RESET:
    case ACTIONS.RESET_MOBILE_HOME:
    case ACTIONS.RESET_ALL_EXCEPT_MONTH:
      return {
        ...INITIAL_STATE,
      };
    case ACTIONS.SET_MOBILE_HOME_LENGTH:
      return {
        ...state,
        mobileHomeLength: action.length,
      };
    default:
      return state;
  }
}

export function setMobileHomeLength(length) {
  return {
    type: ACTIONS.SET_MOBILE_HOME_LENGTH,
    length: Number(length),
  };
}

export function resetMobileHome() {
  return {
    type: ACTIONS.RESET_MOBILE_HOME,
  };
}



// WEBPACK FOOTER //
// ./src/redux/modules/mobilehome.js